import * as types from './types'
import { IPaginatedRequest } from '@cbgms/api'

export const loadDefaultRevenueGroup = (params: IPaginatedRequest) => ({
  type: [types.GET_DEFAULTREVENUEGROUPS, types.GET_DEFAULTREVENUEGROUPS_SUCCESS, types.GET_DEFAULTREVENUEGROUPS_FAILED],
  payload: {
    api: 'support',
    request: {
      method: 'GET',
      url: '/modules/default-revenue-group',
      params
    }
  }
})
